/**
 * SectionTitle — Section heading within a page.
 *
 * Props:
 *   children: string — section title text
 *   actions: ReactNode — optional right-aligned elements
 */

import React from 'react';
import styles from './SectionTitle.module.css';

function SectionTitle({ children, actions }) {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{children}</h2>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}

export default SectionTitle;
